export default __webpack_public_path__ + "static/media/ic_usdc_40.8bf1ff5d.svg";